import { createElement, Fragment } from 'react';

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var GTM_ID = "GTM-MVBT6T8";
var subRoute = process.env.NEXT_PUBLIC_SUB_ROUTE || "/";
var GTMScriptHead = function GTMScriptHead(_ref) {
  var _ref$gtm_id = _ref.gtm_id,
    gtm_id = _ref$gtm_id === void 0 ? GTM_ID : _ref$gtm_id;
  return (
    // eslint-disable-next-line @next/next/next-script-for-ga
    createElement("script", {
      async: true,
      type: "text/javascript",
      dangerouslySetInnerHTML: {
        __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','" + gtm_id + "');"
      }
    })
  );
};
var GTMScriptBody = function GTMScriptBody(_ref2) {
  var _ref2$gtm_id = _ref2.gtm_id,
    gtm_id = _ref2$gtm_id === void 0 ? GTM_ID : _ref2$gtm_id;
  return createElement("noscript", null, createElement("iframe", {
    src: "https://www.googletagmanager.com/ns.html?id=" + gtm_id,
    height: "0",
    width: "0",
    style: {
      display: "none",
      visibility: "hidden"
    }
  }));
};
var RudderStackScript = function RudderStackScript(_ref3) {
  var _ref3$basePath = _ref3.basePath,
    basePath = _ref3$basePath === void 0 ? subRoute : _ref3$basePath,
    fileName = _ref3.fileName;
  var host = "https://universe.staderlabs.com";
  var rsMinJs = basePath + "analytics/" + fileName;
  var dataPlane = host + "/l-p/rs-dataplane";
  var configUrl = host + "/rudderlabs/sourceConfig";
  return createElement(Fragment, null, createElement("script", {
    type: "text/javascript",
    async: true,
    dangerouslySetInnerHTML: {
      __html: "!function(){var e=window.rudderanalytics=window.rudderanalytics||[];e.methods=[\"load\",\"page\",\"track\",\"identify\",\"alias\",\"group\",\"ready\",\"reset\",\"getAnonymousId\",\"setAnonymousId\",\"getUserId\",\"getUserTraits\",\"getGroupId\",\"getGroupTraits\"],e.factory=function(t){return function(){var r=Array.prototype.slice.call(arguments);return r.unshift(t),e.push(r),e}};for(var t=0;t<e.methods.length;t++){var r=e.methods[t];e[r]=e.factory(r)}e.loadJS=function(e,t){var r=document.createElement(\"script\");r.type=\"text/javascript\",r.async=!0,r.src=\"" + rsMinJs + "\";var a=document.getElementsByTagName(\"script\")[0];a.parentNode.insertBefore(r,a)},e.loadJS(),\n          e.load(\"2E0kslmrvgrH84NmPoKKsFKwhP5\",\"" + dataPlane + "\", {configUrl: \"" + configUrl + "\"}),\n          e.page()}();"
    }
  }));
};
var DefaultScripts = function DefaultScripts(_ref4) {
  var _ref4$basePath = _ref4.basePath,
    basePath = _ref4$basePath === void 0 ? subRoute : _ref4$basePath,
    fileName = _ref4.fileName;
  return createElement(Fragment, null, createElement(RudderStackScript, {
    basePath: basePath,
    fileName: fileName
  }));
};
var UTM_PARAMS = {
  utm_referral: true,
  utm_source: true,
  utm_medium: true,
  utm_campaign: true,
  utm_term: true,
  utm_content: true
};
var getReferenceParams = function getReferenceParams() {
  var _window = window,
    location = _window.location;
  // removed use of useRouter as there was delay in fetching url parameters
  // reading params from window.location instead.
  try {
    var searchStr = decodeURIComponent(location.search);
    var xQuery = new URLSearchParams(searchStr);
    var query = {};
    //This step is required else xQuery will always be empty object
    for (var _iterator = _createForOfIteratorHelperLoose(xQuery.entries()), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
        _key = _step$value[0],
        value = _step$value[1];
      query[_key] = value;
    }
    var x = {};
    for (var key in UTM_PARAMS) {
      if (query[key]) {
        x[key] = query[key];
      }
    }
    return x;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("useRefrenceParams error", e);
    return {};
  }
};

export { DefaultScripts, GTMScriptBody, GTMScriptHead, RudderStackScript, getReferenceParams };
//# sourceMappingURL=app-head.esm.js.map
